import styled from 'astroturf/react';

const RowLabel = styled('label')`
  color: var(--ph-gray-600);
  font-size: var(--ph-text-sm);
  margin-bottom: 7px;
  margin-left: 2px;
`;
const RowWrapper = styled('div')`
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  flex-direction: column;
`;
const RowWithText = styled('span')`
  margin-left: 2px;
  margin-bottom: 10px;
`;

export default {
  RowLabel,
  RowWithText,
  RowWrapper,
};
